import { Component } from 'react'
import * as styles from 'components/features/socialFeed/Avatar/Avatar.styl'
import * as cn from 'classnames'
import { Donut } from 'components/features/pfm/Donut/Donut'
import SvgIcon from 'components/atoms/SvgIcon'
import DefaultAvatarSvg from 'icons/user-default-avatar.svg'
import { UserImage } from 'interfaces/userImage'
import AdjustableImage from 'components/features/pfm/AdjustableImage/AdjustableImage'

export type AvatarProps = {
  matchRatio: number | null
  preventDonut?: boolean

  isOwn: boolean
  dim: boolean
  name: string | null
  avatar: Pick<UserImage, 'image' | 'localImage'> | null
}

export class Avatar extends Component<AvatarProps> {
  static defaultProps: Partial<AvatarProps> = {
    isOwn: false,
  }

  render () {
    const {
      matchRatio,
      dim,
      isOwn,
      name,
      avatar,
      preventDonut,
    } = this.props

    const noPeergroup = !isOwn && typeof matchRatio !== 'number'

    const className = cn(
      styles.container,
      {
        [styles.noPeergroup]: noPeergroup,
        [styles.ownAvatar]: isOwn,
        [styles.isDefault]: !name,
        [styles.dim]: dim,
      }
    )

    const ratio = noPeergroup ? 0 : (matchRatio || 0)

    const isPlaceholder = !name && !avatar

    return (
      <div className={ className }>
        { isPlaceholder && (
          <SvgIcon src={ DefaultAvatarSvg } />
        )}
        { !isPlaceholder && (
          <>
            { !preventDonut && <Donut ratio={ ratio } className={ styles.donut } /> }
            <div className={ cn(styles.content, preventDonut && styles.preventDonut) }>
              { avatar && (
                <div className={ styles.image }>
                  <AdjustableImage
                    preventLazyRender
                    image={ avatar.image || avatar.localImage }
                    fitToContainer
                  />
                </div>
              )}
              { name && !avatar && this.renderLetter(name) }
            </div>
          </>
        )}
      </div>
    )
  }

  private renderLetter (name: string) {
    return (
      <svg
        className={ styles.fallbackLetterWrapper }
        xmlns='http://www.w3.org/2000/svg'
        viewBox='0 0 512 512'
      >
        <text
          className={ styles.fallbackLetter }
          textAnchor='middle'
          x='256'
          y='380'
        >
          { name.charAt(0).toLocaleUpperCase() }
        </text>
      </svg>
    )
  }
}

